import { Button, Col, Form, Row } from "antd";
import React, { useState, useEffect } from "react";
import { complete_client_registration } from "../../../../api/endpoints/auth";
import { get_distributors } from "../../../../api/endpoints/distributors";
import { get_sale_departments } from "../../../../api/endpoints/saledepartments";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import SignInTemplate from "../../../layout/sign-in-template/SignInTemplate";
import GeneralInformation from "./components/general-information/GeneralInformation";
import SalesDepartments from "./components/sales-department/SalesDepartments";
import Image from "../../../common/image/Image";
import MarketLogo from "../../../../assets/images/Onetransfer-logo-wbg.png";
import {
	Body,
	Footer,
	Header,
	HeaderDesc,
	HeaderTitle,
	InnerForm,
	LogoWrap,
	Main,
	Page,
	PrimaryButtonWrap,
	SectionCard,
	SectionText,
	SectionTitle,
	TrustDot,
	TrustItem,
	TrustRow,
} from "./styles";
import { useAuth } from "../../../../contexts/authContext";
import DistributorsCode from "../../../common/distributors-code/DistributorsCode";
import {
	ClockCircleOutlined,
	LockOutlined,
	SafetyOutlined,
} from "@ant-design/icons";

const GUTTER = 10;

export default function CompleteUserData() {
	const [form] = Form.useForm();
	const [distributors, setDistributors] = useState(null);
	const [submitting, setSubmitting] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const { user, userdata, updateVerifiedEmail } = useAuth();

	useEffect(() => {
		if (user && !userdata?.emailVerified) {
			updateVerifiedEmail(user.uid, true);
		}
	}, []);

	useEffect(() => {
		const fetch_data = async () => {
			const distributors = await get_distributors();
			const saledepartments = await get_sale_departments();

			const init = {
				distributors: distributors,
				saledepartments: saledepartments,
			};
			setInitialValues(init);
		};

		fetch_data();
	}, []);

	const onFinish = async (values) => {
		try {
			const newDistributor = distributors.map((d) =>
				d.checked === true
					? d.code === undefined || d.code.trim() === ""
						? { ...d, code: null }
						: { ...d, code: d.code.trim() }
					: { ...d, code: null },
			);

			if (newDistributor.filter((d) => d.code !== null).length === 0) {
				setSubmitting(false);
				openNotificationWithIcon(
					TYPE.ERROR,
					"Para avanzar debe seleccionar y cargar el código de al menos una droguería",
				);
				return;
			}

			setSubmitting(true);

			const postData = {
				saleDepartments: values.saledepartments.map((s, i) => ({
					id: s.id,
					selected: s.selected,
					key: `k_${i}`,
				})),
				distributors: newDistributor.map((d, i) => ({
					id: d.id,
					code: d.code,
					key: `k_${i}`,
				})),
			};

			const formData = new FormData();
			formData.append(
				"file",
				values.file?.fileList?.slice(-1)[0]?.originFileObj,
			);
			formData.append("data", JSON.stringify(postData));

			await complete_client_registration(formData);

			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Registro completado",
				"Sus datos se guardaron con éxito.",
			);
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"No se pudo completar la operación",
				"Error al intentar guardar datos de registro",
			);
		} finally {
			setSubmitting(false);
		}
	};

	if (!initialValues) return <div>Loading...</div>;

	return (
		<SignInTemplate columns="1">
			<Page>
				<Main>
					<LogoWrap>
						<Image
							src={MarketLogo}
							alt="Logo One Transfer"
							height="45px"
							width="220px"
						/>
					</LogoWrap>

					<Header>
						<HeaderTitle>Completar datos de usuario</HeaderTitle>
						<HeaderDesc>
							Complete la información restante para terminar su registro en One
							Transfer
						</HeaderDesc>
					</Header>

					<Body>
						<Form
							form={form}
							name="complete-user-registration"
							onFinish={onFinish}
							requiredMark={false}
							layout="vertical"
							wrapperCol={{ span: 24 }}
							initialValues={initialValues}
						>
							<InnerForm>
								<SectionCard style={{ marginTop: 18 }}>
									<SectionTitle>Información general</SectionTitle>
									<SectionText>
										Verifique y complete sus datos de registro.
									</SectionText>

									<Row gutter={GUTTER}>
										<Col span={24} align="start">
											<GeneralInformation form={form} />
										</Col>
									</Row>
								</SectionCard>

								<SectionCard>
									<SectionTitle>Droguerías</SectionTitle>
									<SectionText>
										Ingrese el código de las droguerías con las cuales trabaja.
									</SectionText>

									<Row gutter={GUTTER}>
										<Col span={24} align="start">
											<DistributorsCode
												onChange={setDistributors}
												containerBackground={"#fbfcfd"}
											/>
										</Col>
									</Row>
								</SectionCard>

								<SectionCard>
									<SectionTitle>Rubros / Departamentos de venta</SectionTitle>
									<SectionText>
										Seleccione los rubros que representan mejor su actividad.
									</SectionText>

									<Row gutter={GUTTER}>
										<Col span={24} align="start">
											<SalesDepartments
												form={form}
												initialValues={initialValues.saledepartments}
											/>
										</Col>
									</Row>
								</SectionCard>

								<PrimaryButtonWrap>
									<Button type="primary" htmlType="submit" loading={submitting}>
										Guardar y acceder a One Transfer
									</Button>
								</PrimaryButtonWrap>

								<Footer>
									Una vez completado este paso, podrá comenzar a operar dentro
									del sistema.
								</Footer>

								<TrustRow>
									<TrustItem>
										<SafetyOutlined />
										Conexión segura
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<LockOutlined />
										Datos encriptados
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<ClockCircleOutlined />
										Disponible 24/7
									</TrustItem>
								</TrustRow>
							</InnerForm>
						</Form>
					</Body>
				</Main>
			</Page>
		</SignInTemplate>
	);
}
